/** Accord français : 0 et 1 s'écrivent au singulier, 2 et plus au pluriel. */
export function pluriel(n: number, singulier: string, plurielForme: string): string {
  return Math.abs(n) < 2 ? singulier : plurielForme;
}

/** Libellé qui suit le nombre de salariés dans l'en-tête de la liste : « salarié enregistré » / « salariés enregistrés ». */
export function libelleSalariesEnregistres(n: number): string {
  return pluriel(n, 'salarié enregistré', 'salariés enregistrés');
}
